import type { PartnerFeatureFlag } from '@fukuri-admins/apis/client/gen/model';
import { getClientName, getEmail, getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetClientAdminsPartnerFeatureFlags } from '~/hooks';
import { useAuth } from '~/components/auth/AuthProvider';
import { useConfiguration } from '~/contexts/ConfigurationProvider';

type IUseClientSideMenu = () => {
  state: {
    imageUrl: string;
    email: string;
    clientName: string;
    featureFlags?: PartnerFeatureFlag[];
    isLoading: boolean;
  };
  actions: {
    signOut: () => void;
  };
};

/**
 * サイドメニューの状態・アクションを提供する Component Hook
 *
 * ClientSideMenu は各 Screen から Suspense 境界なしに直接描画されるため、
 * `useGetClientAdminsPartnerFeatureFlags` を `suspense: false` で呼び出す。
 * 取得完了までは featureFlags が undefined・isLoading が true になる。この isLoading を
 * 下流の `convertEnabledMenus` に渡し、ロード中は制限メニューを非表示にする（fail-closed）。
 */
export const useClientSideMenu: IUseClientSideMenu = () => {
  const { applicationConfiguration } = useConfiguration();
  const threeLetterCode = getThreeLetterCode();
  const email = getEmail();
  const clientName = getClientName();
  const { signOut } = useAuth();
  const { data, isLoading } = useGetClientAdminsPartnerFeatureFlags({
    threeLetterCode,
    suspense: false,
  });

  return {
    state: {
      imageUrl: applicationConfiguration?.application_configuration.logo_image.url,
      email,
      clientName,
      featureFlags: data?.partner_feature_flags ?? undefined,
      isLoading,
    },
    actions: {
      signOut,
    },
  };
};
